// Spanish UI strings. Extracted verbatim from viewer.js (UI.es).
// HTML markup in values is preserved intentionally.

import type { UIStrings } from './index';

export const es: UIStrings = {
  'header.walkHint':         '<kbd>←</kbd> <kbd>→</kbd> caminar · arrastra vacío para pan',
  'header.docs':             'docs',
  'header.share.title':      'Compartir',
  'header.settings.title':   'Configuración',
  'header.code.title':       'Ver código fuente',
  'header.zoom.title':       'Zoom',
  'header.zoom.fit':         'Ajustar a la pantalla',
  'header.search.title':     'Buscar (⌘K)',
  'search.placeholder':      'Buscar nodes…',
  'search.empty':            'Ningún node coincide.',
  'code.eyebrow':            'código',
  'code.title':              'Código <em>· fuente cruda</em>',
  'code.copy':               'Copiar',
  'code.download':           'Descargar',
  'code.empty':              'No hay código fuente disponible para este mapa.',
  'code.undo':               'Deshacer (⌘Z)',
  'code.redo':               'Rehacer (⌘⇧Z)',
  'code.status.saved':       'aplicado',
  'code.status.editing':     'editando',
  'code.status.error':       'inválido — manteniendo anterior',
  'loading':                 'Cargando datos del lifecycle…',
  'splash.title':            'lifecycle-map <em>— viewer</em>',
  'splash.eyebrow':          'visor interactivo de lifecycle en swim-lane',
  'splash.lead':             'Renderiza cualquier mapa de lifecycle desde JSON o YAML. Cinco formas de cargar:',
  'splash.example.h':        'Prueba un ejemplo →',
  'splash.example.p':        'Carga el ejemplo de pipeline de contratación para explorar el schema y las interacciones.',
  'splash.exampleMl.h':      'Prueba multi-idioma →',
  'splash.exampleMl.p':      'Un ejemplo más pequeño con strings en <code>en</code>, <code>pt</code>, y <code>es</code>. Cambia el idioma en <strong>Configuración → Idioma</strong>.',
  'splash.url.h':            'Cargar desde URL → <code>?src=https://…</code>',
  'splash.url.p':            'Pasa una URL de JSON o YAML como parámetro. Funciona con Gists públicos, URLs raw de GitHub, o cualquier endpoint con CORS.',
  'splash.hash.h':           'Embebido en URL → <code>#data=…</code>',
  'splash.hash.p':           'URLs auto-contenidas con JSON comprimido en el fragment. Excelente para agentes IA — sin hospedaje.',
  'splash.dnd.h':            'O simplemente arrastra un archivo →',
  'splash.dnd.p':            'Suelta un archivo <code>.json</code> o <code>.yaml</code> en cualquier lugar de esta página.',
  'splash.paste.h':          'Pega JSON o YAML',
  'splash.paste.render':     'Renderizar',
  'splash.paste.cancel':     'Cancelar',
  'splash.footer.docs':      'Documentación',
  'splash.footer.github':    'GitHub',
  'splash.footer.license':   'Licencia MIT',
  'settings.title':          'Configuración <em>· a tu manera</em>',
  'settings.theme':          'Tema',
  'settings.appearance':     'Apariencia',
  'settings.language':       'Idioma',
  'settings.uiLanguage':     'Idioma de la interfaz',
  'settings.dataLanguage':   'Idioma del mapa',
  'settings.mode.light':     'Claro',
  'settings.mode.dark':      'Oscuro',
  'settings.foot.docs':      'Leer la documentación',
  'settings.foot.github':    'Ver en GitHub',
  'settings.foot.license':   'Licencia MIT',
  'dnd.title':               'Suelta para cargar',
  'dnd.sub':                 'Suelta en cualquier lugar — parseamos JSON o YAML',
};
